export default __webpack_public_path__ + "static/media/USDT.1cb1a19f.svg";